import { FetchRequestActions } from "../../../../utils/request-actions-helpers/createRequestActions"
import { createRequestActionTypes } from "../../../../utils/request-actions-helpers/createRequestActionTypes"
import { ApiConfig } from "../../../../config/ApiConfig"
import { RequestThunkParameters, createRequestThunk } from "../../../../utils/request-actions-helpers/createRequestThunk"

interface SavedItemsUpdateResponse {
    userSavedItemsDocIds: string[]
}

const processSavedItemsUpdateResponse = (result: SavedItemsUpdateResponse) => {
    return result.userSavedItemsDocIds
}

export type SavedItemsUpdate = string[]

export type SavedItemsChangeAction = FetchRequestActions<SavedItemsUpdate>

export const saveItemActionTypes = createRequestActionTypes("SAVE_ITEM")

export const saveItemToFavorites = (config: ApiConfig, docId: string) => {
    const thunkParams: RequestThunkParameters<SavedItemsUpdate, string> = {
        method: 'POST',
        body: docId,
        requestActionTypes: saveItemActionTypes,
        url: `${config.API_URL}/savedItems/addItem`,
        processResultBeforeDispatch: processSavedItemsUpdateResponse
    }
    return createRequestThunk(thunkParams)
}


export const removeItemFromSavedActionTypes = createRequestActionTypes("REMOVE_ITEM_FROM_SAVED")

export const removeItemFromSaved = (config: ApiConfig, docId: string) => {
    const thunkParams: RequestThunkParameters<SavedItemsUpdate, string> = {
        method: 'POST',
        body: docId,
        requestActionTypes: removeItemFromSavedActionTypes,
        url: `${config.API_URL}/savedItems/removeItem`,
        processResultBeforeDispatch: processSavedItemsUpdateResponse
    }
    return createRequestThunk(thunkParams)
}